import React from 'react';
import { Money, Logout, SubtractAlt, Gift, Portfolio } from '@carbon/react/icons';
import StatCard from 'src/components/Employee/StatCard';
import { useMoney } from 'src/hooks/useMoney';

interface EmployeeIncomesProps {
  employeeIncomes: any;
}

const EmployeeIncomes = React.memo((props: EmployeeIncomesProps) => {
  const { decimals, format } = useMoney();
  const baseSalary = props.employeeIncomes?.employee?.salary || 0;
  return (
    <div className={'incomes'}>
      <h5 className={'section__heading'}>Your Incomes</h5>
      <div className="stats">
        <StatCard
          title={'Total incomes'}
          onClick={() => null}
          value={8000000}
          format={format}
          decimals={decimals}
          icon={<Money size={36} />}
        />
        <StatCard
          title={'Base Salary'}
          onClick={() => null}
          value={baseSalary}
          format={format}
          decimals={decimals}
          icon={<Portfolio size={36} />}
        />
        <StatCard
          title={'Total Bonus'}
          onClick={() => null}
          value={8000000}
          format={format}
          decimals={decimals}
          icon={<Gift size={36} />}
        />
        <StatCard
          title={'Total Fines'}
          onClick={() => null}
          value={8000000}
          format={format}
          decimals={decimals}
          icon={<SubtractAlt size={36} />}
        />
        <StatCard
          title={'Total Day Off'}
          onClick={() => null}
          value={8000000}
          format={format}
          decimals={decimals}
          icon={<Logout size={36} />}
        />
      </div>
    </div>
  );
});

export default EmployeeIncomes;
